<template>    
    <div class="home">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Parte {{$store.state.parteDetalle}}          
        </v-card-title>
        
        <v-layout wrap align-center>     
            <v-flex xs7 offset-xs1>
                <v-autocomplete
                    v-model="user"
                    :items="users"
                    item-text="Name"
                    item-value="User"
                    label="Acompañante/s"
                    hint="Seleccione acompañante/s (opcional)"
                    persistent-hint
                    chips
                    multiple
                    :disabled="$store.state.parteDetalleObject.posted || $store.state.parteDetalleObject.vb"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs7 offset-xs1>
                <v-text-field :disabled="$store.state.parteDetalleObject.posted || $store.state.parteDetalleObject.vb" :error="errorJobField" :error-messages="errorJobFieldMessage" v-model="proyecto" @click="openJobDialog" type="text" label="Proyecto" readonly></v-text-field>
            </v-flex>       
            <v-flex xs2 offset-xs1 mt-3>
                <v-layout row wrap >
                    <v-flex xs12>
                        Titular
                        <br>
                        <v-checkbox
                        :disabled="true/*$store.state.parteDetalleObject.posted || $store.state.parteDetalleObject.vb*/"
                        v-model="driver"
                        class="ma-0 pa-0 ml-6"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs7 offset-xs1>
               
            </v-flex>
            <v-flex xs2 offset-xs1 >
                <v-layout row wrap >
                    <v-flex xs12>
                        Revisión
                        <br>
                        <v-checkbox
                        v-model="revision"
                        class="ma-0 pa-0 ml-6"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm10 offset-sm1 mb-3>
              <TimeTable/>
            </v-flex>
        </v-layout>                
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <v-footer absolute padless>
            <v-flex  v-if="$store.state.storedImages.length > 0" xs10 offset-xs1 mb-3>
              <v-btn :disabled="($store.state.parteDetalleObject.posted) || ($store.state.parteDetalleObject.vb)"  block color="warning" dark @click="openDocumentImagesDialog">Ver fotos adjuntas</v-btn>
            </v-flex> 
            <v-flex v-if="driver" xs10 offset-xs1 mb-3>
              <v-btn :disabled="($store.state.parteDetalleObject.posted) || ($store.state.parteDetalleObject.vb)" block color="primary" dark @click="openTaskTimeDialog">Facturación</v-btn>
            </v-flex> 
            <v-flex xs10 offset-xs1 mb-3>
              <v-btn :disabled="($store.state.parteDetalleObject.posted) || ($store.state.parteDetalleObject.vb)" block color="primary" dark @click="openTaskTimeDialogPersonal">Parte de trabajo</v-btn>
            </v-flex>                          
            <br>
            <v-flex xs4 offset-xs1>
              <v-btn large block color="error" dark @click="close">Cerrar</v-btn>
            </v-flex>  
            <v-flex xs4 offset-xs2>
              <v-btn :disabled="($store.state.parteDetalleObject.posted) || ($store.state.parteDetalleObject.vb)" large block color="success" dark @click="openSummaryDialog">Modificar</v-btn>
            </v-flex>  
        </v-footer>
        <!--v-footer v-else>
            <v-flex xs10></v-flex>
            <v-flex xs10 offset-xs1>
              <v-btn large block color="error" dark @click="close">Cerrar</v-btn>
            </v-flex> 
        </v-footer-->
    </div>
</template>
<script>
import TimeTable from '@/components/TimeTable.vue'
export default {
    name: 'ParteDetalle',
    components:{
      TimeTable
    },
    data () {
      return {      
        errorJobField: false,
        errorJobFieldMessage: ''          
      }
    },
    methods:{
        close(){
            this.$store.commit('resetDataAfterSuccessfulCreation');
            //this.dialog = false;                        
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Agenda');
        },
        closeOK(){            
            //this.dialog = false;                        
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Agenda');
        },       
        openJobDialog(){
            if (this.lineas.length > 0){
                this.errorJobField = true;
                this.errorJobFieldMessage = 'No se puede cambiar el proyecto con lineas ya imputadas'
                var thisaux = this;
                setTimeout(function(){
                    thisaux.errorJobField = false;
                    thisaux.errorJobFieldMessage = ''
                },3000);
            } else {
                this.dialogProyecto = true;
            }
        },
        openTaskTimeDialog(){
          if (this.proyecto == ''){
            this.errorJobField = true;
            this.errorJobFieldMessage = 'Rellene primero el proyecto'
            var thisaux = this;
            setTimeout(function(){
              thisaux.errorJobField = false;
              thisaux.errorJobFieldMessage = ''
            },3000);
          } else {
            this.$router.push('Horas');
          }
        },
        openTaskTimeDialogPersonal(){
          if (this.proyecto == ''){
            this.errorJobField = true;
            this.errorJobFieldMessage = 'Rellene primero el proyecto'
            var thisaux = this;
            setTimeout(function(){
              thisaux.errorJobField = false;
              thisaux.errorJobFieldMessage = ''
            },3000);
          } else {
            this.$router.push('HorasPersonal');
          }
        },
        openSummaryDialog(){
            //this.dialog = false;
            //this.dialogSummary = true;
            this.$router.push('ResumenEdit');
        },
        openDocumentImagesDialog(){
            this.dialogDocumentImages = true;
        },
        deleteDocument(){
            this.$store.commit('resetDataAfterSuccessfulCreation');
        }
    },
    mounted(){
      this.getUsers();
    },
    watch:{      
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogParteDetalle;
            },
            set(value){
                this.$store.state.dialogParteDetalle = value;
            }
        },
        dialogProyecto: {
            get(){
                return this.$store.state.dialogProyecto;
            },
            set(value){
                this.$store.state.dialogProyecto = value;
            }
        },
        dialogInputHoras: {
            get(){
                return this.$store.state.dialogInputHoras;
            },
            set(value){
                this.$store.state.dialogInputHoras = value;
            }
        },
        dialogInputHorasPersonal: {
            get(){
                return this.$store.state.dialogInputHorasPersonal;
            },
            set(value){
                this.$store.state.dialogInputHorasPersonal = value;
            }
        },
        dialogSummary: {
            get(){
                return this.$store.state.dialogSummary;
            },
            set(value){
                this.$store.state.dialogSummary = value;
            }
        },
        dialogDocumentImages: {
            get(){
                return this.$store.state.dialogDocumentImages;
            },
            set(value){
                this.$store.state.dialogDocumentImages = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.jobs;
            }
        },
        tareas:{
            get(){
                return this.$store.state.jobTasks;
            }
        },
        proyecto:{
            get(){
                //return this.$store.state.proyecto;
                var jobno = this.$store.state.proyecto;
                var fullname = jobno;
                if (jobno != ''){
                  var res = this.proyectos.find(job =>{
                    return job.no == jobno;
                  });
                  if (res){
                    fullname = jobno + ' - ' + res.description;
                  }
                }
                return fullname;
            }/*,
            set(value){
                this.$store.state.proyecto = value;
            }*/
        },
        proyectoFullName:{
            get(){
                var jobno = this.$store.state.proyecto;
                var fullname = '';
                if (jobno != ''){
                  var res = this.$store.state.proyectos.find(job =>{
                    return job.no == jobno;
                  });
                  console.log(res);
                }
                return fullname;
            }
        },
        tarea:{
            get(){
                return this.$store.state.tarea;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        driver:{
            get(){
                return this.$store.state.driver;
            },
            set(value){
                this.$store.commit('saveDriver', value);
            }
        },
        lineas:{
            get(){
                return this.$store.state.lineasParte;
            }            
        },
        revision:{
            get(){
                return this.$store.state.revision;
            },
            set(value){
                this.$store.commit('saveRevision', value);
            }
        },
        users:{
            get(){
                return this.$store.state.users;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        user:{
            get(){
                return this.$store.state.user;
            },
            set(value){
                this.$store.commit('saveUser', value);
            }
        },
    }
}
</script>